import { render, staticRenderFns } from "./InTheFieldProjectItem.vue?vue&type=template&id=6df2bd2b&scoped=true&"
import script from "./InTheFieldProjectItem.vue?vue&type=script&lang=js&"
export * from "./InTheFieldProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./InTheFieldProjectItem.vue?vue&type=style&index=0&id=6df2bd2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2bd2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VImg,VRow})
